import { CtrlType, Ctrl } from "@yuigoto/ctrl";

export const ComissionControl = [
    [
        {
            name: "dateFrom",
            required: true,
            requiredMessage: "Preencher a data é obrigatório",
            placeholder: "DD/MM/AAAA",
            label: "Data início",
            wrapClass: "col-6 col-sm-6 col-md-3",
            type: CtrlType.DATE
        },
        {
            name: "dateTo",
            placeholder: "DD/MM/AAAA",
            label: "Data fim",
            wrapClass: "col-6 col-sm-6 col-md-3",
            type: CtrlType.DATE
        },
        {
            name: "description",
            required: true,
            label: "Descrição",
            requiredMessage: "Preencher a descrição é obrigatório",
            wrapClass: "col-6 col-sm-6 col-md-3"
        },
        {
            name: "influencerStatusRestriction",
            label: "InfluencerStatus",
            wrapClass: "col-6 col-sm-6 col-md-3",
            type: CtrlType.DROPDOWN,
            options: [
                {
                    "value": "",
                    "name": ""
                },
                {
                    "value": "1",
                    "name": "Glampartner VIP"
                },
                {
                    "value": "2",
                    "name": "Glampartner"
                },
                {
                    "value": "3",
                    "name": "Glamdiva VIP"
                },
                {
                    "value": "4",
                    "name": "Glamdiva"
                },
                {
                    "value": "5",
                    "name": "Glamqueen"
                }

            ]
        }
    ],       
    [
        
        {
            name: "businessUnity",
            label: "Business Unity",
            wrapClass: "col-12 sm-12 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório.",
            type: CtrlType.DROPDOWN,
            options: [{"value": null, "name":  "Escolha uma opção"},
                {"value": 2,"name": "Glamshop"},
                {"value": 3,"name": "B4A Connect"}
            ]
        },
        {
            name: "influencerPaymentTypeId",
            alias: "paymentTypeId",
            label: "Tipo",
            wrapClass: "col-6 col-sm-6 col-md-6",
            required: true,
            requiredMessage: "Este campo é obrigatório.",
            type: CtrlType.DATALIST,
            options: []
        },
        {
            name: "paymentDescription", 
            wrapClass: "col-6 col-sm-6 col-md-6",           
            type: CtrlType.HIDDEN
        }
       
    ],
    {
        name: "value",
        label: "Value",
        required: true,
        description: "OBS: Se valor percentual, digitar por ex.: 0.10",
        requiredMessage: "Preencher a comissão é obrigatório",
        wrapClass: "col-6 col-sm-6 col-md-4",
    }
]